module.exports = __webpack_public_path__ + "img/vertical_spacing.d3a9b99a.svg";